const img = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const neighborhoods = [
  {
    slug: "coral-gables",
    name: "Coral Gables",
    median: "$1.65M",
    image: img("photo-1523217582562-09d0def993a6"),
    tagline: { en: "The City Beautiful", es: "La Ciudad Hermosa" },
    description: {
      en: "Historic banyan canopies, Mediterranean revival estates, and some of the best schools in the county. Coral Gables is timeless Miami prestige — tree-lined streets, the Venetian Pool, and Miracle Mile dining minutes away.",
      es: "Históricos dosel de banianos, casonas mediterráneas y algunas de las mejores escuelas del condado. Coral Gables es el prestigio atemporal de Miami — calles arboladas, la Piscina Veneciana y la gastronomía de Miracle Mile a minutos.",
    },
    vibe: { en: "Prestige · Top Schools · Mediterranean", es: "Prestigio · Escuelas Top · Mediterráneo" },
    highlights: {
      en: ["Top-rated public & private schools", "Venetian Pool & historic landmarks", "Miracle Mile shopping and dining", "Lush banyan-lined streets"],
      es: ["Escuelas públicas y privadas de primer nivel", "Piscina Veneciana y sitios históricos", "Compras y restaurantes en Miracle Mile", "Calles frondosas llenas de banianos"],
    },
  },
  {
    slug: "brickell",
    name: "Brickell",
    median: "$780K",
    image: img("photo-1506966953602-c20cc11f75e3"),
    tagline: { en: "The Manhattan of the South", es: "El Manhattan del Sur" },
    description: {
      en: "Glass towers, rooftop pools, and the pulse of Miami's financial district. Brickell is for those who want the city at their doorstep — walkable, electric, and minutes from everything.",
      es: "Torres de cristal, piscinas en azoteas y el pulso del distrito financiero de Miami. Brickell es para quienes quieren la ciudad a su puerta — caminable, eléctrico y a minutos de todo.",
    },
    vibe: { en: "Urban · Financial District · Nightlife", es: "Urbano · Distrito Financiero · Vida Nocturna" },
    highlights: {
      en: ["Walkable to Brickell City Centre", "Waterfront high-rise living", "Miami's dining & nightlife epicenter", "Metrorail & Metromover access"],
      es: ["Cercano a Brickell City Centre", "Vida en torres frente al agua", "Epicentro gastronómico y nocturno de Miami", "Acceso a Metrorail y Metromover"],
    },
  },
  {
    slug: "coconut-grove",
    name: "Coconut Grove",
    median: "$1.95M",
    image: img("photo-1518495973542-4542c06a5843"),
    tagline: { en: "Bohemian elegance under the canopy", es: "Elegancia bohemia bajo el dosel" },
    description: {
      en: "Miami's oldest neighborhood wraps you in lush tropical canopy, sailing clubs, and a laid-back artistic soul. The Grove is where character, coast, and community meet.",
      es: "El vecindario más antiguo de Miami te envuelve en un dosel tropical, clubes de vela y un alma artística relajada. El Grove es donde el carácter, la costa y la comunidad se encuentran.",
    },
    vibe: { en: "Artistic · Coastal · Walkable", es: "Artístico · Costero · Caminable" },
    highlights: {
      en: ["Sailboat Bay & marinas", "CocoWalk and village cafés", "Banyan canopy streets", "Strong community feel"],
      es: ["Bahía de veleros y marinas", "CocoWalk y cafés del pueblo", "Calles con dosel de banianos", "Fuerte sentido de comunidad"],
    },
  },
  {
    slug: "doral",
    name: "Doral",
    median: "$695K",
    image: img("photo-1587174486073-ae5e5cff23aa"),
    tagline: { en: "Modern living, championship golf", es: "Vida moderna, golf de campeonato" },
    description: {
      en: "Gated enclaves, championship golf courses, and newer construction make Doral a favorite for families and professionals who want space, security, and modern amenities.",
      es: "Comunidades cerradas, campos de golf de campeonato y construcción nueva hacen de Doral un favorito para familias y profesionales que buscan espacio, seguridad y amenidades modernas.",
    },
    vibe: { en: "Family · Contemporary · Business Hub", es: "Familiar · Contemporáneo · Centro de Negocios" },
    highlights: {
      en: ["Trump National Doral golf", "Newer gated communities", "Top charter schools", "Major employment hub"],
      es: ["Golf en Trump National Doral", "Comunidades cerradas nuevas", "Escuelas charter destacadas", "Gran centro de empleo"],
    },
  },
  {
    slug: "kendall",
    name: "Kendall",
    median: "$620K",
    image: img("photo-1570129477492-45c003edd2be"),
    tagline: { en: "Space, serenity, and value", es: "Espacio, serenidad y valor" },
    description: {
      en: "Expansive single-family lots, quiet streets, and strong schools — Kendall offers some of the best value per square foot in Miami-Dade, with room to grow.",
      es: "Amplios lotes unifamiliares, calles tranquilas y buenas escuelas — Kendall ofrece uno de los mejores valores por pie cuadrado en Miami-Dade, con espacio para crecer.",
    },
    vibe: { en: "Suburban · Spacious · Strong Schools", es: "Suburbano · Espacioso · Buenas Escuelas" },
    highlights: {
      en: ["Large single-family lots", "A-rated school zones", "Parks & family amenities", "Strong value growth"],
      es: ["Lotes unifamiliares grandes", "Zonas escolares calificación A", "Parques y amenidades familiares", "Fuerte crecimiento de valor"],
    },
  },
  {
    slug: "miami-beach",
    name: "Miami Beach",
    median: "$1.2M",
    image: img("photo-1507525428034-b723cf961d3e"),
    tagline: { en: "Iconic oceanfront living", es: "Icónica vida frente al océano" },
    description: {
      en: "Art Deco heritage, oceanfront towers, and a cultural scene that draws the world. Miami Beach is the postcard — and for a lucky few, home.",
      es: "Herencia Art Déco, torres frente al mar y una escena cultural que atrae al mundo. Miami Beach es la postal — y para unos pocos afortunados, el hogar.",
    },
    vibe: { en: "Luxury Beachfront · Global · Iconic", es: "Lujo Frente al Mar · Global · Icónico" },
    highlights: {
      en: ["Oceanfront & bay views", "Art Deco historic district", "World-class dining & culture", "Resort-style amenities"],
      es: ["Vistas al océano y la bahía", "Distrito histórico Art Déco", "Gastronomía y cultura de clase mundial", "Amenidades estilo resort"],
    },
  },
];
